// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"_4a2589dd","stickyLogo":"_ef136ed1","stickyTradeLogo":"_326fb6d7"};